import { makeStyles, Theme } from '@material-ui/core'

import { ToggleButtonProps } from './ToggleButtonProps'

export const useToggleButtonStyles = makeStyles<Theme, ToggleButtonProps>((theme) => ({
  root: {
    color: theme.palette.text.primary,
  },
  selected: {
    '&&': {
      '&:hover': {
        backgroundColor: (props) => theme.palette[props.color || 'primary'].dark,
      },
      backgroundColor: (props) => theme.palette[props.color || 'primary'].main,
      color: 'white',
    },
  },
}))
